exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-card{cursor:pointer}", "", {"version":3,"sources":["/../../sass-loader/index.js?sourceMap!/buddy/fm-connect-xamarin/client/app/components/apps/client/app/components/apps/youtube/youtube.scss"],"names":[],"mappings":"AAAA,YACE,cAAe,CAChB","file":"youtube.scss","sourcesContent":[".video-card {\n  cursor: pointer;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sass-loader?sourceMap!./client/app/components/apps/youtube/youtube.scss
// module id = 566
// module chunks = 0